import React from 'react';
import ReactTooltip from 'react-tooltip';

export class TabsComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentTabId: props.currentTabId || null,
            currentTabIndex: props.currentTabIndex || null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentTabId !== prevProps.currentTabId ||
            this.props.currentTabIndex !== prevProps.currentTabIndex) {
            this.setState({
                currentTabId: this.props.currentTabId,
                currentTabIndex: this.props.currentTabIndex,
            });
        }
    }

    onTabClick = (e) => {
        const id = e.target.dataset.tabId;
        const index = parseInt(e.target.dataset.tabIndex, 10);

        this.setState({
            currentTabId: id,
            currentTabIndex: index,
        });

        if (this.props.onChange) {
            this.props.onChange({ id, index });
        }
    };

    render() {
        const { className, tabs, currentTabId, currentTabIndex, valueName, valueKey } = this.props;
        return <div className={`alan-tabs ${className}`}>
            {tabs.map((tab, index) => {
                const byIndex = valueKey === 'index';
                const key = byIndex ? index : tab.id;
                const isActive = byIndex ? (index === currentTabIndex) : (tab.id === currentTabId);
                let tabClassName = "alan-tabs__tab";
                if (isActive) {
                    tabClassName += " alan-tabs__tab_active";
                }
                return <div
                    key={key}
                    className={tabClassName}
                    data-tab-id={tab.id}
                    data-tab-index={index}
                    onClick={tab.disabled ? undefined : this.onTabClick}
                    data-for={key}
                    data-tip={tab.tooltip}
                    data-place="top"
                    data-effect="solid"
                    data-class="tutor-light-tooltip tutor-no-arrow-tooltip"
                >
                    {tab.image && <img className="alan-tabs__icon" src={tab.image} />}
                    <span
                        data-tab-id={tab.id}
                        data-tab-index={index}
                        title={tab[valueName]}
                        className={`alan-tabs__title ${tab.disabled && 'disabled'}`}>
                        {tab[valueName]}
                    </span>
                    {tab.tooltip && <ReactTooltip id={key} />}
                </div>;
            })}
        </div>;
    }
}
